export const WORDS = [
"makes", "takes"
];
